
import { LeadershipPlusFqGrowthValue, LeadershipPlusLevelAchievedValue } from '@utils/sections/LeadershipPlusIncentive.util'
import { makeAutoObservable } from 'mobx'
import { makePersistable } from 'mobx-persist-store'

interface LeadershipPlusIncentiveData {
  leadershipPlusIncentiveActive: boolean
  leadershipPlusIncentiveLevelAchieved: LeadershipPlusLevelAchievedValue
  leadershipPlusIncentiveFqGrowth: LeadershipPlusFqGrowthValue
}

export class LeadershipPlusIncentiveStore implements LeadershipPlusIncentiveData {
  leadershipPlusIncentiveActive!: boolean
  leadershipPlusIncentiveLevelAchieved!: LeadershipPlusLevelAchievedValue
  leadershipPlusIncentiveFqGrowth!: LeadershipPlusFqGrowthValue

  constructor() {
    this.reset()
    makeAutoObservable(this, {}, { autoBind: true })
    makePersistable(this, {
      name: `${AIS_STORE}-LeadershipPlusIncentive`,
      properties: ['leadershipPlusIncentiveActive', 'leadershipPlusIncentiveLevelAchieved', 'leadershipPlusIncentiveFqGrowth']
    })
  }

  reset() {
    this.leadershipPlusIncentiveActive = true
    this.leadershipPlusIncentiveLevelAchieved = LeadershipPlusLevelAchievedValue.BELOW_F_PLATINUM
    this.leadershipPlusIncentiveFqGrowth = LeadershipPlusFqGrowthValue.MAINTAIN
  }

  setLeadershipPlusIncentiveActive(value: boolean) { this.leadershipPlusIncentiveActive = value }
  setLeadershipPlusIncentiveLevelAchieved(value: LeadershipPlusLevelAchievedValue) { this.leadershipPlusIncentiveLevelAchieved = value }
  setLeadershipPlusIncentiveFqGrowth(value: LeadershipPlusFqGrowthValue) { this.leadershipPlusIncentiveFqGrowth = value }
}
